import axios from "axios";

export const createProduct = async (product) => {
    const response = await axios.post(`/api/products`, { product });
    return response.data;
};

export const updateProduct = async product => {
    const response = await axios.put(`/api/products`, { product });
    return response.data;
};

export const getProduct = async id => {
    const response = await axios.get(`/api/products/${id}`);
    return response.data;
};

export const getProductsForTenant = async tenantId => {
    const response = await axios.get(`/api/tenant/products/${tenantId}`);
    return response.data;
};

export const deleteProduct = async id => {
    const response = await axios.delete(`/api/products/${id}`);
    return response.data;
};
